import {useEffect, useState} from 'react';
import {useInterceptor, useLoadAds} from '@jobseeker/common-core';
import {Box, Button, Link, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {Banner} from '@jobseeker/lotus/images';
import {shallowEqual, useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';
import {getRefTagAndOrigin, handleTracking} from '@jobseeker/common-core/utils';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {getOldLink} from '@jobseeker/lotus/utils';

export const calculateRefMapping = (refCode: string): string => {
  const obj: Record<string, string> = {
    jf: 'Jobfeed',
    jd: 'JD',
    kp: 'CategoryPage',
    svj: 'SavedJob',
    apj: 'AppliedJob',
  };

  return obj[refCode] || ''; // Simplified return
};

export const getDevice = (userAgent: string): string => {
  const isMobile =
    /(iPad|iPhone|Android|webOS|iPod|BlackBerry|IEMobile|Opera Mini|Mobile)/i.test(
      userAgent
    ) || false;

  if (isMobile) {
    if (/android/i.test(userAgent)) {
      return 'android';
    }

    if (/iphone|ipad|ipod|iPhone|ios/.test(userAgent)) {
      return 'ios';
    }
  }

  return 'web';
};

const useUserAgent = () => {
  const [userAgent, setUserAgent] = useState<string>('');

  useEffect(() => {
    if (typeof navigator !== 'undefined') {
      setUserAgent(navigator.userAgent || navigator.vendor || '');
    }
  }, []);

  return userAgent;
};

interface CityPageListingProps {
  type: string;
}

const DownloadAppBanner: React.FC<CityPageListingProps> = ({type}) => {
  if (type !== 'EarlyApplicant') {
    return;
  }
  const [bdata, setBdata] = useState<any>({});
  const interceptor: any = useInterceptor();
  const {
    ads: {hiristDownloadBanner},
    gaEvents: {downloadApp: banner},
  } = interceptor;

  // const slots = {
  //   MIDDLE: hiristDownloadBanner?.[1]?.slot,
  // };
  // useLoadAds(slots.MIDDLE, setBdata);
  console.log({bdata});
  const {isLoggedIn, userId} = useSelector((state: AppState) => state.auth);
  const {device} = useSelector(
    (state: AppState) => state.app.layout,
    shallowEqual
  );
  const userAgent = useUserAgent();

  useEffect(() => {
    const device = getDevice(userAgent);

    const {refText} = getRefTagAndOrigin();
    handleTracking('jsViewMobileAppListingBanner', {
      event_category: 'MobileAppPromotion',
      Origin: `${calculateRefMapping(refText)}`,
      Device: 'Mobile',
      Type: `${device === 'ios' ? 'iOS' : 'Android'}`,
      UserId: `${userId}`,
      Status: `${isLoggedIn ? 'LoggedIn' : 'LoggedOut'}`,
    });
  }, []);

  const redirectToApp = (redirectLink: any) => {
    const {refText} = getRefTagAndOrigin();
    const bannerId = (new Date().getDate() % 3) + 1;

    handleTracking('jsClickMobileAppListingBanner', {
      event_category: 'MobileAppPromotion',
      Origin: `${calculateRefMapping(refText)}`,
      Device: 'Mobile',
      Type: `${device === 'ios' ? 'iOS' : 'Android'}`,
      UserId: `${userId}`,
      Status: `${isLoggedIn ? 'LoggedIn' : 'LoggedOut'}`,
    });
    openUrl(redirectLink);
  };

  return (
    <>
      <Box
        sx={{
          backgroundImage: `url(${Banner})`, // Ensure the correct syntax
          backgroundSize: 'cover', // Adjust as needed
          backgroundPosition: 'center', // Adjust as needed
          bgcolor: '#13355c',
          display: 'flex',
          px: {xxs: 2.5, md: 6},
          py: {xxs: 2.25, md: 4},
          borderRadius: {xxs: 3},
          ml: 2,
          mt: 2,
          mr: 1.5,
        }}
      >
        {type == 'EarlyApplicant' ? (
          <>
            <>
              <Box display="flex" alignItems="center" flex="1">
                <Image
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAiCAMAAAAnKQpfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABIUExURUdwTP//4f+/Kf/FLv+/KP/CLf+/KP+/Kf/AKf/KNv/AKf+/KP+/KP/AKv+/Kf+/Kf+/KP+/KP/BK/+/Kf+/KP+/Kf+/Kf++KAX0DW0AAAAXdFJOUwABqQ+/Gfv0PARS6uBEebRp8CnXyJSBRhWSlQAAAZRJREFUOMvFVduygyAMVJSLoIKg3f//0xOo9UCFzvSpOx2nQBI3mwS77tfgzBjGv3KZ+AbC9p2XBePcwrYt+kHrMma/Yei6AVtfcs7snATEIz+fhJhez/9IDwFI91xowDIBl8cccUzTgTHfcxDMAjot9mi/YM4NvIGUMD7fm7FEzz0tZOTfmfS8+Omons59Bpj03NIqQFGOokz6wEG/UhxBKiiEtFoxOx2wLXlYCe8h85cvG4J2M9YnFRupkIKZgCyWiIqVSZdMSLOXoPrYwVaBkV8WkjTw8orDR4iVYT/yNLkQXBkYFwmp8dRAUxwVyTo6UtGm7ApGXDmjIoed2s6c+S2GGnAPVFTLKXf21kpUJ2KibOQ9r5cAwzrThrAUpE91KrstPLd67snjUoT+DIp2+lfYEq+X91OjrdkpdtHptzTfprJ6XolUY1KTojlzdxlyKepohaQeHJuYG+Q5PqIuUy+gmgAaCZdz2N0nsIYA33Ly5+zdsccRrkOdV0PthtRTA7p5b7JP4rGGkzayCaN/8h36A5tNHYcT17qLAAAAAElFTkSuQmCC"
                  alt="crown_img"
                  width={36}
                  height={24}
                  style={{
                    marginRight: '6px',
                  }}
                />
                <Box pl={'16px'}>
                  <Typography
                    sx={{
                      fontSize: 16,
                      fontWeight: 'normal',
                      color: '#fff',
                      opacity: 0.8,
                    }}
                  >
                    Be an early applicant on jobs
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 'bold',
                      color: '#fff',
                      mt: 0,
                    }}
                  >
                    Get notified as soon as a relevant job is posted{' '}
                  </Typography>
                </Box>
              </Box>
              <Box
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                ml={'8px'}
              >
                <Link
                  href={getOldLink(
                    `/subscribe/plans?scrollTo=earlyApplicant&ref=topnavigation&source=${
                      window.location.href.includes('/k/')
                        ? 'KeywordPage'
                        : 'CategoryPage'
                    }&origin=${
                      window.location.href.includes('/k/')
                        ? 'tagfeed'
                        : 'categoryfeed'
                    }`
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="none"
                  sx={{
                    display: 'inline-block',
                    textDecoration: 'none',
                    width: '80px',
                    height: '30px',
                    borderRadius: '5px',
                    backgroundColor: '#f5582d',
                    padding: '8px 12px',
                    mt: 0.5,
                    '&:hover': {
                      backgroundColor: '#f5582d',
                    },
                  }}
                  onClick={() => {
                    const device = getDevice(userAgent);

                    const {refText} = getRefTagAndOrigin();
                    handleTracking('Subscription', {
                      event_category: 'jsClickEA_ListingLinkage',
                      Origin: `${calculateRefMapping(refText)}`,
                      Device: device === 'ios' ? 'iOS' : 'Android',
                      Type: device === 'ios' ? 'iOS' : 'Android',
                      UserId: userId,
                      Status: isLoggedIn ? 'LoggedIn' : 'LoggedOut',
                    });
                  }}
                >
                  <Typography
                    sx={{fontSize: 11, fontWeight: 'bold', color: '#fff'}}
                  >
                    SEE HOW
                  </Typography>
                </Link>
              </Box>
            </>
          </>
        ) : (
          <>
            {bdata[0]?.imageUrl ? (
              <>
                <Image
                  src={bdata[0]?.imageUrl}
                  alt="hirist"
                  height={48}
                  width={48}
                  unoptimized
                />
                <Box pl={'16px'}>
                  <Typography
                    sx={{fontSize: 17, fontWeight: 'bold', color: '#fff'}}
                  >
                    {bdata[0]?.description
                      ?.split(',')
                      .map((part: any, index: any, array: any) => (
                        <span key={index}>
                          {part}
                          {index < array.length - 1 ? ',' : ''}{' '}
                          {/* Adds comma only if not last item */}
                          <br /> {/* Ensures line break */}
                        </span>
                      ))}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 15,
                      fontWeight: 'normual',
                      color: '#fff',
                      mt: 0,
                    }}
                  >
                    {bdata[0]?.subText}
                  </Typography>
                  <Button
                    sx={{
                      borderRadius: '5px',
                      backgroundColor: '#f5582d',
                      padding: '4px 8px 3px',
                      mt: 0.5,
                      ':hover': {
                        backgroundColor: '#f5582d',
                      },
                    }}
                    onClick={() => {
                      redirectToApp(bdata[0]?.link);
                    }}
                  >
                    <Typography
                      sx={{fontSize: 11, fontWeight: 'bold', color: '#fff'}}
                    >
                      INSTALL NOW{' '}
                    </Typography>
                  </Button>
                </Box>
              </>
            ) : (
              <></>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default DownloadAppBanner;
